import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { Input } from '@/components/ui/input'

interface NumberFieldProps {
  field: FieldSchema
  value: number
  onChange: (value: number) => void
}

export const NumberField = ({ field, value, onChange }: NumberFieldProps) => {
  return (
    <Input
      type="number"
      value={value || 0}
      onChange={(e) => onChange(Number(e.target.value))}
      className="h-12 text-sm font-medium focus-visible:ring-primary/20"
      placeholder={field.placeholder}
    />
  )
}
